import { pickUserIdFromAuthUser, readPersistedSessionIds } from './sessionIds';
import { emptyUserPrefsV1, mergeUserPrefsPatch, readUserPrefsDoc } from './userPrefs';

/**
 * @param {unknown} blob
 * @returns {{ places: string[], halls: string[] }}
 */
export function normalizeAnalysesStatsVenueUi(blob) {
    if (!blob || typeof blob !== 'object') {
        return { places: [], halls: [] };
    }
    const places = Array.isArray(blob.places)
        ? blob.places.map((x) => String(x)).filter(Boolean)
        : [];
    const halls = Array.isArray(blob.halls)
        ? blob.halls.map((x) => String(x)).filter(Boolean)
        : [];
    return { places, halls };
}

/** @returns {{ places: string[], halls: string[] }} */
export function readPersistedAnalysesStatsVenueUi() {
    if (typeof window === 'undefined' || !window.localStorage) {
        return { places: [], halls: [] };
    }
    try {
        const { userId } = readPersistedSessionIds();
        if (!userId) {
            return { places: [], halls: [] };
        }
        const doc = readUserPrefsDoc(userId) || emptyUserPrefsV1();
        return normalizeAnalysesStatsVenueUi(doc.analysesStatsVenueUi);
    } catch (_e) {
        return { places: [], halls: [] };
    }
}

/**
 * @param {string|null|undefined} userId
 * @param {{ places?: unknown, halls?: unknown }} venue
 */
export function persistAnalysesStatsVenueUi(userId, venue) {
    if (!userId) {
        return;
    }
    if (typeof window === 'undefined' || !window.localStorage) {
        return;
    }
    try {
        mergeUserPrefsPatch(userId, {
            analysesStatsVenueUi: normalizeAnalysesStatsVenueUi(venue),
        });
    } catch (_e) {
        /* ignore */
    }
}

/**
 * Resolve prefs user id from Redux auth, falling back to the session snapshot.
 * @param {object|null|undefined} authUser
 */
export function resolveAnalysesStatsVenueUserId(authUser) {
    return pickUserIdFromAuthUser(authUser) || readPersistedSessionIds().userId;
}
